import { Component } from '@angular/core';

@Component({
  selector: 'app-duplicate-enumeration',
  templateUrl: './duplicate-enumeration.component.html',
  styleUrls: ['./duplicate-enumeration.component.scss']
})
export class DuplicateEnumerationComponent {

  showDts : boolean = false;
  showBuildings : boolean = true;



}
